import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../../lib/supabase';

const NewsletterSection = () => {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubscribe = async (e) => {
    e?.preventDefault();
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/?.test(email)) {
      setError('Skriv inn en gyldig e-postadresse.');
      return;
    }
    setError('');
    setLoading(true);
    try {
      const { error: dbError } = await supabase?.from('contact_optins')?.insert({ email, optin_email: true, source: 'newsletter' });
      if (dbError) throw dbError;
    } catch (err) {
      console.error('Newsletter subscription error:', err);
    } finally {
      setLoading(false);
      setSubscribed(true);
      navigate('/newsletter-subscription-thank-you-page');
    }
  };

  return (
    <section style={{
      background: '#0A1220',
      padding: '100px 5%',
      position: 'relative',
      overflow: 'hidden',
      borderTop: '1px solid rgba(255,255,255,0.06)'
    }}>
      <div style={{
        position: 'absolute', top: '-40px', right: '-20px',
        fontFamily: 'Impact, Arial Black, sans-serif',
        fontSize: 'clamp(180px, 25vw, 320px)',
        fontWeight: 900, color: 'rgba(59,111,212,0.04)',
        lineHeight: 1, userSelect: 'none', pointerEvents: 'none',
        letterSpacing: '-0.05em'
      }}>01</div>
      <div style={{
        position: 'absolute', top: 0, left: '40%', width: '1px',
        height: '100%', background: 'rgba(232,148,26,0.08)',
        transform: 'rotate(8deg)', transformOrigin: 'top center',
        pointerEvents: 'none'
      }} />
      <div style={{ maxWidth: '1400px', margin: '0 auto', position: 'relative', zIndex: 1 }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1.2fr',
          gap: '80px',
          alignItems: 'center'
        }}>
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '24px' }}>
              <div style={{ width: '40px', height: '1px', background: '#E8941A' }} />
              <span style={{
                fontFamily: 'JetBrains Mono, monospace', fontSize: '0.65rem',
                color: '#E8941A', letterSpacing: '0.25em', textTransform: 'uppercase'
              }}>NYHETSBREV</span>
            </div>

            <h2 style={{
              fontFamily: 'Impact, Arial Black, sans-serif',
              fontSize: 'clamp(42px, 6vw, 80px)',
              fontWeight: 900, color: '#EEF0F2',
              lineHeight: 0.9, letterSpacing: '-0.03em',
              textTransform: 'uppercase', margin: '0 0 8px'
            }}>HOLD DEG</h2>
            <h2 style={{
              fontFamily: 'Georgia, serif',
              fontStyle: 'italic',
              fontSize: 'clamp(36px, 5vw, 68px)',
              fontWeight: 700, color: '#3B6FD4',
              lineHeight: 0.95, letterSpacing: '-0.02em',
              margin: '0 0 32px'
            }}>oppdatert.</h2>

            <p style={{
              fontFamily: 'Georgia, serif', fontStyle: 'italic',
              fontSize: '1.05rem', color: 'rgba(238,240,242,0.55)',
              lineHeight: 1.7, maxWidth: '380px', margin: '0 0 24px'
            }}>
              Fa de siste nyhetene om norske veier, bomstasjoner og NordPass-oppdateringer direkte i innboksen din.
            </p>

            <div style={{
              display: 'inline-block',
              background: 'rgba(232,148,26,0.08)',
              border: '1px solid rgba(232,148,26,0.2)',
              padding: '6px 14px',
              transform: 'rotate(-1.5deg)',
              fontFamily: 'Georgia, serif', fontStyle: 'italic',
              fontSize: '0.75rem', color: 'rgba(232,148,26,0.7)',
              letterSpacing: '0.03em'
            }}>
              Ingen spam - vi lover.
            </div>
          </div>

          <div style={{
            background: 'rgba(255,255,255,0.02)',
            border: '1px solid rgba(255,255,255,0.07)',
            padding: '48px',
            position: 'relative',
            overflow: 'hidden'
          }}>
            <div style={{
              position: 'absolute', top: 0, left: 0, right: 0, height: '3px',
              background: 'linear-gradient(90deg, #3B6FD4, #E8941A)'
            }} />

            {subscribed ? (
              <div style={{ textAlign: 'center', padding: '32px 0' }}>
                <div style={{
                  display: 'inline-block',
                  border: '3px solid #3B6FD4',
                  padding: '16px 32px',
                  transform: 'rotate(-3deg)',
                  marginBottom: '24px'
                }}>
                  <div style={{
                    fontFamily: 'Impact, Arial Black, sans-serif',
                    fontSize: '1.4rem', color: '#3B6FD4',
                    letterSpacing: '0.15em', textTransform: 'uppercase'
                  }}>BEKREFTET</div>
                </div>
                <p style={{
                  fontFamily: 'Georgia, serif', fontStyle: 'italic',
                  fontSize: '1rem', color: 'rgba(238,240,242,0.6)',
                  lineHeight: 1.6
                }}>
                  Takk! Du er na abonnert pa NordPass-nyhetsbrevet.
                </p>
              </div>
            ) : (
              <form onSubmit={handleSubscribe}>
                <div style={{ marginBottom: '28px' }}>
                  <label style={{
                    display: 'block',
                    fontFamily: 'JetBrains Mono, monospace', fontSize: '0.65rem',
                    color: 'rgba(238,240,242,0.4)', letterSpacing: '0.2em',
                    textTransform: 'uppercase', marginBottom: '10px'
                  }}>E-POSTADRESSE</label>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => { setEmail(e?.target?.value); setError(''); }}
                    placeholder="din@epost.no"
                    style={{
                      width: '100%', background: 'rgba(255,255,255,0.04)',
                      border: error ? '1px solid #E8941A' : '1px solid rgba(255,255,255,0.1)',
                      padding: '14px 18px',
                      fontFamily: 'Inter, sans-serif', fontSize: '0.95rem',
                      color: '#EEF0F2', outline: 'none',
                      boxSizing: 'border-box',
                      transition: 'border-color 0.2s'
                    }}
                  />
                  {error && (
                    <div style={{
                      fontFamily: 'JetBrains Mono, monospace', fontSize: '0.65rem',
                      color: '#E8941A', marginTop: '6px', letterSpacing: '0.05em'
                    }}>{error}</div>
                  )}
                </div>

                <button
                  type="submit"
                  disabled={loading}
                  style={{
                    width: '100%',
                    background: loading ? 'rgba(59,111,212,0.5)' : '#3B6FD4',
                    border: 'none',
                    padding: '16px 32px',
                    fontFamily: 'Syne, sans-serif', fontSize: '0.8rem',
                    fontWeight: 700, color: '#EEF0F2',
                    letterSpacing: '0.12em', textTransform: 'uppercase',
                    cursor: loading ? 'not-allowed' : 'pointer',
                    clipPath: 'polygon(0 0, calc(100% - 10px) 0, 100% 10px, 100% 100%, 10px 100%, 0 calc(100% - 10px))',
                    transition: 'background 0.2s'
                  }}
                  onMouseEnter={(e) => { if (!loading) e.target.style.background = '#2d5ab8'; }}
                  onMouseLeave={(e) => { if (!loading) e.target.style.background = '#3B6FD4'; }}
                >
                  {loading ? 'Sender...' : 'ABONNER NA'}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewsletterSection;